import { getContext } from 'svelte';
import { MARKDOWN_CONTEXT } from '../../constants/contexts';

export const getMarkdownContext = () => {
	return getContext<{ domain: string }>(MARKDOWN_CONTEXT);
};
